import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["elevation", "interactive", "showSkeleton", "className", "runningText", "children"];
import React from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { borderColor, borderRadius, borders, boxShadow, color, display, fontSize, fontWeight, overflow, space, style, textAlign, themeGet } from 'styled-system';
import { Classes } from '@blueprintjs/core';
import borderColors from './utils/borderColors';
import flex from './utils/flex';
import grid from './utils/grid';
import size from './utils/size';
import position from './utils/position';
var StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-kgsftc-0"
})(["&&{", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", "}"], borderColor, borderRadius, borders, boxShadow, display, color, display, fontSize, fontWeight, space, overflow, position, style({
  prop: 'overflowX'
}), style({
  prop: 'overflowY'
}), style({
  prop: 'transition'
}), textAlign, borderColors, flex, grid, size, function (_ref) {
  var theme = _ref.theme,
    bg = _ref.bg;
  return theme.name === 'dark' && css(["&.", "{background:", ";border:1px solid ", ";box-shadow:none;}"], Classes.CARD, themeGet("colors.".concat(bg), theme.colors.cardBackground), theme.colors.cardBorder);
});
var Card = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$elevation = _ref2.elevation,
    elevation = _ref2$elevation === void 0 ? 0 : _ref2$elevation,
    _ref2$interactive = _ref2.interactive,
    interactive = _ref2$interactive === void 0 ? false : _ref2$interactive,
    showSkeleton = _ref2.showSkeleton,
    className = _ref2.className,
    runningText = _ref2.runningText,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledCard, _extends({
    ref: ref,
    className: classNames(Classes.CARD, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "bp4-elevation-".concat(elevation), true), Classes.RUNNING_TEXT, runningText), Classes.INTERACTIVE, interactive), Classes.SKELETON, showSkeleton)),
    p: 0
  }, rest), children);
});
export default Card;